export const DEFAULT = "/";
export const ACCOUNTS = "/accounts";
export const SETTINGS = "/settings";
export const HERDPRODUCTIVITY = "/herd-productivity";
export const FEEDBUNK_MGMT = "/feedbunk-management";
export const PEOPLE_PROTOCOLS = "/people-and-protocols";
export const REPORTS = "/reports";
export const HERD_WELFARE = "/herd-welfare";
export const DASHBOARD = "/dashboard";
